var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPenTool01V2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 13l-1.3-6.498c-.072-.363-.108-.545-.197-.692a1 1 0 00-.312-.325c-.144-.094-.324-.138-.684-.225L2 2m0 0l3.26 13.507c.087.36.13.54.225.684a1 1 0 00.325.312c.147.088.329.125.692.197L13 18M2 2l7.586 7.586m6.545 11.283l4.738-4.738c.396-.396.594-.594.668-.822a1 1 0 000-.618c-.074-.228-.272-.426-.668-.822l-.738-.738c-.396-.396-.594-.594-.822-.668a1 1 0 00-.618 0c-.228.074-.426.272-.822.668L13.13 17.87c-.396.396-.594.594-.668.822a1 1 0 000 .618c.074.228.272.426.668.822l.738.738c.396.396.594.594.822.668a1 1 0 00.618 0c.228-.074.426-.272.822-.668zM13 11a2 2 0 11-4 0 2 2 0 014 0z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgPenTool01V2;